export default({
	data: function () {
		return {
			username: '',
			email: '',
			login: '',
			password: '',
			rep_password: '',
			address: '',
			organization: '',
			payment: '',
			phone: '',
			role: '',
            selected: 1,
            arm0: '',
            payment_details: '',
			error: '',
		};
	},


	beforeCreate:
	    function () {
		    this.$http.get('/user/roles_list').then(response => {
			    var body = JSON.parse(response.body.response_body);
			    this.role = body;

            }, error => {
                this.setError('Couldn\'t get role list from server.');
		    });
	    },

    methods: {
        setError: function (e) {
            this.error    = e;
        },

		save: function () {
            var data = {};
			data.user_name       = this.username;
            data.password        = this.password;
            data.login           = this.login;
            data.address         = this.address;
            data.email           = this.email;
            data.organization    = this.organization;
            data.phone           = this.phone;
            data.payment_details = this.payment_details;
			data.user_role       = this.selected;
			data.validateOnly    = false;

			this.$http.post('/account/register', data).then(response => {
                var body = response.body;
                if (this.rep_password !== this.password) {
                    this.setError('Passwords do not match');
                } else if (body.response_status === 0) {
                    this.setError('');
                } else {
                    var error_list = [];
                    if (body.response_body != "") {
                        var errors = JSON.parse(body.response_body);

                        for (var k in errors) {
                            if (errors[k] !== '') {
                                error_list.push(errors[k]);
                            }
                        }

                        this.setError(error_list.join('. <br />'));
                    } else {
                        this.setError(body.error_message);
                    }
				}
			}, error => {
                this.setError('Something went wrong with our server. Please contact System Administrator (code ' + error.status + ')');
			});
		}
	}
});


// WEBPACK FOOTER //
// ./src/components/external/registration/registration.js